import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface SafetySectionProps {
  currentLang: string;
}

export default function SafetySection({ currentLang }: SafetySectionProps) {
  const { t } = useTranslation('home');

  const safetyPoints = [
    { icon: 'ri-shield-check-line', text: 'Account Security' },
    { icon: 'ri-lock-line', text: 'Payment Safety' },
    { icon: 'ri-user-search-line', text: 'Seller Verification' },
    { icon: 'ri-camera-lens-line', text: 'QC Photos' },
    { icon: 'ri-link-m', text: 'Avoid Suspicious Links' },
    { icon: 'ri-alert-line', text: 'Scam Awareness' },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 sm:px-6 lg:px-10 xl:px-16 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-12">
          <span className="text-accent-500 text-xs font-semibold uppercase tracking-[0.15em] mb-3 block">
            Safety
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground-900 mb-4">
            {t('safety_h2')}
          </h2>
          <p className="text-foreground-600 text-base md:text-lg leading-relaxed max-w-2xl mx-auto">
            {t('safety_copy')}
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5 mb-10 md:mb-12">
          {safetyPoints.map((point) => (
            <div key={point.text} className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/40 text-center">
              <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-3">
                <i className={`${point.icon} text-accent-600 text-base`}></i>
              </div>
              <p className="text-foreground-700 text-sm font-medium">{point.text}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to={`/${currentLang}/safety/`}
            className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-background-50 font-label font-semibold text-sm rounded-md hover:bg-accent-600 transition-colors"
          >
            {t('safety_cta')}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}